module.exports = __webpack_public_path__ + "img/g1.7004f48e.jpg";